// extracted by mini-css-extract-plugin
module.exports = {"pt-news-detail":"pt-news-detail-a82db4c3e4962c213e45311934981769","date-from":"date-from-212076a4026b1304fd06b0fd353c8e3f"};